/**
 * Household API Client
 * Handles household creation, joining, leaving, and management
 */

import { apiRequest } from './queryClient';
import type {
  Household,
  AppUser,
  CreateHouseholdRequest,
  JoinHouseholdRequest,
} from '../types/household';

export class HouseholdClient {
  /** Get the current user's profile (includes activeSpaceId) */
  static async getMe(): Promise<AppUser> {
    const response = await apiRequest('GET', '/users/me');
    return response.json();
  }

  /** Get the current user's household, or null if in personal space */
  static async getMyHousehold(): Promise<Household | null> {
    const response = await apiRequest('GET', '/households/me');
    const data = await response.json();
    return data.household;
  }

  /** Create a new household */
  static async createHousehold(req: CreateHouseholdRequest): Promise<Household> {
    const response = await apiRequest('POST', '/households', req);
    return response.json();
  }

  /** Join a household via invite code */
  static async joinHousehold(req: JoinHouseholdRequest): Promise<Household> {
    const response = await apiRequest('POST', '/households/join', req);
    return response.json();
  }

  /** Leave the current household */
  static async leaveHousehold(): Promise<void> {
    await apiRequest('POST', '/households/leave');
  }

  /** Generate a fresh invite code (24-hour expiry) */
  static async refreshInviteCode(): Promise<Household> {
    const response = await apiRequest('POST', '/households/refresh-code');
    return response.json();
  }
}
